import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import apiDecorator from 'api/api-decorator';
import { reportError } from 'api/api-errors';
import { emit } from 'helpers/global-events';
import Button, { btnThemes } from 'components/button';
import Notification from 'components/notification';

@apiDecorator
export default class ApprovePost extends PureComponent {
  static propTypes = {
    // Current post id
    postId: PropTypes.number.isRequired,
  };

  constructor(...args) {
    super(...args);
    this.approvePost = this.approvePost.bind(this);
  }

  /**
   * Approve post in DB.
   *
   * @param postId
   */
  approvePost(postId) {
    this.api.post('action/forum/actions-approve-post/approve', {
      postData: {
        postId
      }
    })
      .then(() => this.afterApprovePost())
      .catch(error => reportError(error));
  }

  // Call after success approve post.
  afterApprovePost() {
    Notification.success('Сообщение одобрено.');

    // Make reload data provider club posts.
    emit('updateClubPosts');

    // Make reload data provider for TopicInfo and posts.
    emit('updatePosts');
  }

  render() {
    const { postId } = this.props;

    return (
      <Button
        onClick={() => this.approvePost(postId)}
        // iconType={iconTypes.announcement}
        title="Одобрить"
        label="Одобрить"
        theme={btnThemes.sky}
      />
    );
  }
}
